import { render, staticRenderFns } from "./ChatNotice.vue?vue&type=template&id=93722048&scoped=true"
import script from "./ChatNotice.vue?vue&type=script&lang=js"
export * from "./ChatNotice.vue?vue&type=script&lang=js"
import style0 from "./ChatNotice.vue?vue&type=style&index=0&id=93722048&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93722048",
  null
  
)

export default component.exports